import type { RequestView } from './types.js';

export function formatRequestOrigin(request: RequestView, chinaFallback: string): string {
  if (request.kind === 'CONTAINER' || request.kind === 'SIMPLE') {
    const pickupAddress = request.pickupAddress?.trim();
    if (pickupAddress) return pickupAddress;
    return chinaFallback;
  }
  return request.route.from || '—';
}
